fragment ContentBlockText on contentBlocks_richText_BlockType {
    richText

    anchorId
    anchorLabel
}
